// Локальное (только для этого устройства) оформление: фон, цветовая схема,
// светлая/тёмная тема. Используется, когда у пользователя выключена
// синхронизация оформления (user.theme_sync === false).
//
// Ключ — отдельно для каждого пользователя. Голый _id не подходит:
// под ним уже лежит кэш аватара, который регулярно удаляется.
export const APPEARANCE_KEY_PREFIX = "taskpal_appearance_";

export const appearanceKey = (userId) => APPEARANCE_KEY_PREFIX + userId;

const THEME_NAMES = ["default", "fresh"];

// localStorage может править кто угодно — берём только ожидаемые поля и типы
function sanitize(value) {
  if (!value || typeof value != "object") return null;

  const result = {};
  const theme = value.theme;

  if (theme && typeof theme == "object") {
    result.theme = {};
    if (THEME_NAMES.includes(theme.name)) result.theme.name = theme.name;
    if (typeof theme.color == "string" && /^#[0-9a-f]{3,8}$/i.test(theme.color))
      result.theme.color = theme.color;
    if (typeof theme.dark_mode == "boolean")
      result.theme.dark_mode = theme.dark_mode;
  }

  if (typeof value.background_image == "string" && value.background_image) {
    result.background_image = value.background_image;
  }

  return result.theme || result.background_image ? result : null;
}

function storage() {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
}

export function readLocalAppearance(userId) {
  const ls = storage();
  if (!userId || !ls) return null;
  try {
    return sanitize(JSON.parse(ls.getItem(appearanceKey(userId))));
  } catch (e) {
    return null;
  }
}

export function writeLocalAppearance(userId, appearance) {
  const ls = storage();
  const value = sanitize(appearance);
  if (!userId || !ls || !value) return;
  try {
    ls.setItem(appearanceKey(userId), JSON.stringify(value));
  } catch (e) {
    // переполнение/запрет хранилища — оформление просто не запомнится
  }
}

// Замена localStorage.clear() при выходе: всё остальное стираем,
// локальное оформление пользователей оставляем.
export function clearStorageKeepingAppearance() {
  const ls = storage();
  if (!ls) return;

  const kept = [];
  for (let i = 0; i < ls.length; i++) {
    const key = ls.key(i);
    if (key && key.startsWith(APPEARANCE_KEY_PREFIX)) {
      kept.push([key, ls.getItem(key)]);
    }
  }

  ls.clear();
  kept.forEach(([key, value]) => ls.setItem(key, value));
}
